<!-- @format -->

<word-cloud>
  <style>
    .word-cloud {
      width: 100%;
    }
  </style>

  <div class="word-cloud"></div>

  <script>
    import { Random } from "@model/utils.js";
    import * as d3 from "d3";
    import * as cloud from "d3-cloud";

    export default {
      onBeforeMount(prosp, state) {
        state = {
          layout: null,
        };
      },
      onMounted(props, state) {
        const width = this.$(".word-cloud").clientWidth;
        const height = (width / 4) * 3;
        this.generateWordCloud(width, height, props.data);
      },
      shouldUpdate(newProps, currentProps) {
        if (JSON.stringify(newProps) != JSON.stringify(currentProps)) {
          const width = this.$(".word-cloud").clientWidth;
          const height = (width / 4) * 3;
          this.generateWordCloud(width, height, newProps.data);
        }
      },
      generateWordCloud(width, height, data) {
        if (this.state.layout) {
          this.state.layout.stop();
          this.$(".word-cloud").innerHTML = "";
        }
        if (data.length == 0) {
          return;
        }
        for (let d of data) {
          if (!d.sizeOriginal) {
            d.sizeOriginal = d.size;
          }
        }
        const color = d3.interpolate("#FFFFFF", "#F96D87");
        const max = Math.sqrt(data[0].sizeOriginal);

        const rand = new Random();
        const layout = cloud()
          .random(() => (rand.next() % 10000000) / 10000000)
          .size([width, height])
          .words(data)
          .padding(1)
          .rotate((v, i) => 0)
          .font("Impact")
          .fontSize((d) => Math.sqrt(d.sizeOriginal) * 5)
          .on("end", (words) => {
            d3.select(this.$(".word-cloud"))
              .append("svg")
              .attr("width", layout.size()[0])
              .attr("height", layout.size()[1])
              .append("g")
              .attr(
                "transform",
                `translate(${layout.size()[0] / 2}, ${layout.size()[1] / 2})`
              )
              .selectAll("text")
              .data(words)
              .enter()
              .append("text")
              .style("font-size", (d) => {
                return d.size + "px";
              })
              .style("font-family", "Impact")
              .style("fill", (d, i) => {
                return color(Math.sqrt(d.sizeOriginal) / max);
              })
              .attr("text-anchor", "middle")
              .attr("transform", (d) => {
                return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
              })
              .text((d) => {
                return d.text;
              });
          });

        layout.start();
        this.state.layout = layout;
      },
    };
  </script>
</word-cloud>
